import React from 'react'

export const useOnTruthy = (
  cb: React.EffectCallback,
  deps: React.DependencyList,
  mode: 'every' | 'some' = 'every'
) => {
  React.useEffect(() => {
    if (!deps[mode](Boolean)) {
      return
    }

    cb()
  }, deps)
}
